import { Component } from '@angular/core';
import { BaseComponent } from '../../base-component/base.component';
@Component({
  selector: 'favie-page-content-layout',
  templateUrl: './page-content-layout.component.html',
})
export class PageContentLayoutComponent extends BaseComponent {}
